import {CommissionSeance, CommissionSeanceInterface} from '../api/CommissionSeance';
import {DateWithoutTime} from "../../core/dateTools/DateWithoutTime";

export class ExComissionSeanceStatut {
    public code = 0; //0 - 1 - 2
    public label = 'A venir';
}

export class ExComissionSeance extends CommissionSeance {

    public reunionIsOpen = false;
    public reunionIsPassed = false;
    public reunionHasbegun = false;

    constructor(options = null) {
        super();
        if (options) {
            Object.assign(this, options);
        }


        const dateNow = new Date();
        const dateDebut = new Date(this.datetimeDebut);
        const dateFin = new Date(this.datetimeFin);

        this.reunionIsOpen = dateDebut <= dateNow && dateNow <= dateFin;
        this.reunionIsPassed = dateFin < dateNow;
        this.reunionHasbegun = dateDebut <= dateNow;
    }

    static sortCommissionSeancesByDate = (a: CommissionSeanceInterface, b: CommissionSeanceInterface): number => (a.datetimeDebut < b.datetimeDebut) ? -1 : 1;

    /**
     * Renvoie {code : xx , label : xxx};
     *
     * @returns
     */
    public getStatus(): ExComissionSeanceStatut {
        const dateDuJour = new Date();
        dateDuJour.setHours(0, 0, 0, 0);

        const dateDebut = new DateWithoutTime(this.datetimeDebut);
        const dateFin = new DateWithoutTime(this.datetimeFin);

        const statut = new ExComissionSeanceStatut();

        if (dateDebut.isBefore(dateDuJour) && dateFin.isAfter(dateDuJour)) {
            statut.code = 1;
            statut.label = 'En cours';
        }
        if (dateFin.isStrictlyBefore(dateDuJour)) {
            statut.code = 2;
            statut.label = 'Passé';
        }

        return statut;
    }
}
